import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import GoogleAnalytics from "react-ga";
import { Publisher } from "../../shared/pubsub/publisher.js"; // adjust path if needed

if (process.env.GA_TRACKING_ID) {
  GoogleAnalytics.initialize(process.env.GA_TRACKING_ID);
}

const WithTracker = (WrappedComponent, options = {}, moreProps) => {
  const trackPage = function(page, user) {
    GoogleAnalytics.set({
      page: page,
      ...options,
    });
    GoogleAnalytics.pageview(page);

    if (typeof window !== "undefined") {
      window.last_url = page;
      try {
        if (window.Intercom) {
          window.Intercom("update");
        }
      } catch (e) {
        // no-op
      }
    }

    // Existing channel
    Publisher.publish("track.pageView", { page: page });

    // New track-mp channel with user from redux
    if (user) {
      Publisher.publish(`track-mp.pageView.${page}`, { user: user, page: page });
    }

    // For visibility during development
    /* eslint-disable no-console */
    console.log("withTracker Track Page", page);
    /* eslint-enable no-console */
  };

  const shouldTrack = function(page) {
    if (typeof window === "undefined") {
      return true;
    }
    if (!window.last_url) {
      return true;
    } else if (window.last_url && window.last_url !== page) {
      return true;
    }
    return false;
  };

  // eslint-disable-next-line react/no-multi-comp
  class HOC extends Component {
    componentDidMount() {
      if (this.props && this.props.location) {
        var page = this.props.location.pathname + this.props.location.search;
        if (page && page.length > 0) {
          var lastChar = page[page.length - 1];
          if (["?", "/"].indexOf(lastChar) >= 0) {
            page = page.substring(0, page.length - 1);
          }
        }
        if (shouldTrack(page)) {
          trackPage(page, this.props.user);
        }
      }
    }

    componentDidUpdate(prevProps) {
      if (!prevProps || !prevProps.location || !this.props || !this.props.location) {
        return;
      }

      var currentPage = prevProps.location.pathname + prevProps.location.search;
      var nextPage = this.props.location.pathname + this.props.location.search;

      if (nextPage && nextPage.length > 0) {
        var lastChar = nextPage[nextPage.length - 1];
        if (["?", "/"].indexOf(lastChar) >= 0) {
          nextPage = nextPage.substring(0, nextPage.length - 1);
        }
      }

      if (currentPage !== nextPage) {
        if (shouldTrack(nextPage)) {
          trackPage(nextPage, this.props.user);
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} {...moreProps} />;
    }
  }

  function mapStateToProps(state) {
    return {
      user: state && state.user ? state.user : null,
    };
  }

  return withRouter(connect(mapStateToProps)(HOC));
};

export default WithTracker;
